import { useEffect } from "react";

const setMeta = (key, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, image }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    if (title) {
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");
    if (image) {
      setMeta("og:image", image, "property");
      setMeta("twitter:image", image);
    }
  }, [title, description, image]);
  return null;
};

const OG = "https://customer-assets-jt897jd0.emergentagent.net/job_vision-value-growth/artifacts/kxiy6s7x_IMG_0012%202.jpeg";

export const ROUTE_SEO = {
  "/": {
    title: "Ethikally — Finance, explained ethically.",
    description: "Markets, tax, and money decisions broken down clearly by a team of Chartered Accountants and CFA charterholders. Vision · Value · Growth.",
    image: OG,
  },
  "/about": {
    title: "About — Ethikally",
    description: "Why we started Ethikally: rigorous, evidence-based financial guidance from a team that has underwritten credit, audited public companies, and managed investment portfolios.",
    image: OG,
  },
  "/services": {
    title: "Services — Ethikally",
    description: "Financial planning, debt advisory, business consultancy, valuation, content partnerships, and financial literacy workshops. Get a tailored quote.",
    image: OG,
  },
  "/content": {
    title: "Content Hub — Ethikally",
    description: "Learn something in under two minutes. Short, clear explainers on macro, tax, IPOs, and policy.",
    image: OG,
  },
  "/insights": {
    title: "Insights — Ethikally",
    description: "Long-form, evidence-based reads on Indian markets, tax law, IPOs, and policy from the Ethikally team.",
    image: OG,
  },
  "/contact": {
    title: "Contact — Ethikally",
    description: "Get in touch with the Ethikally team for brand partnerships, workshops, service inquiries, and more.",
    image: OG,
  },
};
